const icons = {
    list: <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-numbers" width="20"
               height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
               strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M11 6h9"></path>
        <path d="M11 12h9"></path>
        <path d="M12 18h8"></path>
        <path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"></path>
        <path d="M6 10v-6l-2 2"></path>
    </svg>,
}

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const blackList = {
    id: 'black-list',
    title: 'Black List',
    type: 'group',
    role: [2],
    children: [
        {
            id: '/black-list',
            title: 'Black List',
            type: 'item',
            url: '/black-list',
            icon: icons.list,
            role: [2],
            breadcrumbs: false
        },
    ]
};

export default blackList;